import { Capacitor } from '@capacitor/core';
import { Network, type PluginListenerHandle } from '@capacitor/network';
import { isNetworkAvailable } from '~/helpers/network';

export const useConnectionStatus = () => {
	const isOnline = ref<boolean | null>(null);
	let nativeListener: PluginListenerHandle | null = null;

	const handleBrowserOffline = () => {
		isOnline.value = false;
	};
	const handleBrowserOnline = () => {
		isOnline.value = true;
	};

	const updateNativeStatus = (status: { connected: boolean; connectionType: string }) => {
		isOnline.value = isNetworkAvailable(status);
	};

	const handleVisibilityChange = () => {
		if (document.visibilityState === 'visible' && Capacitor.isNativePlatform()) {
			void Network.getStatus().then(updateNativeStatus).catch((error) => {
				console.error('Failed to read native network status:', error);
			});
		}
	};

	onMounted(async () => {
		if (Capacitor.isNativePlatform()) {
			try {
				nativeListener = await Network.addListener('networkStatusChange', updateNativeStatus);
				updateNativeStatus(await Network.getStatus());
				document.addEventListener('visibilitychange', handleVisibilityChange);
				return;
			} catch (error) {
				console.error('Failed to subscribe to native network status:', error);
			}
		}

		isOnline.value = navigator.onLine;
		window.addEventListener('online', handleBrowserOnline);
		window.addEventListener('offline', handleBrowserOffline);
	});

	onUnmounted(() => {
		window.removeEventListener('online', handleBrowserOnline);
		window.removeEventListener('offline', handleBrowserOffline);
		document.removeEventListener('visibilitychange', handleVisibilityChange);
		void nativeListener?.remove();
	});

	return isOnline;
};
